import { z } from 'zod';
import { paymentTermsSchema } from '../../common';
import { pricePositiveSchema } from '../../validation';

export const agreementTermsSchema = z.object({
  /** when to issue invoice & when to pay the invoice */
  payment: paymentTermsSchema,

  /** if 0, then we cover nothing when a damage happens */
  itemsInsuranceCoveragePerVehicle: pricePositiveSchema,
});

export type AgreementTerms = z.infer<typeof agreementTermsSchema>;
